import CheckoutHelpers from "helpers/CheckoutHelpers";
import LocalStorageHelper from "helpers/LocalStorageHelper";
import useCanDo from "hooks/useCanDo";
import useLocalStorage from "hooks/useLocalStorage";
import useFeatureFlag from "providers/FeatureFlagProvider/useFeatureFlag";
import useOrganisation from "contexts/OrganisationContext/useOrganisation";

function useLaunchBannerEligibility(): boolean {
  const canDoSubscription = useCanDo("subscription.any");
  const showSensorBannerFeatureFlag = useFeatureFlag("sensor-upsell-banner");
  const organisation = useOrganisation();
  const [isSensorBannerVisible] = useLocalStorage(LocalStorageHelper.keys.showSensorUpsellBanner, true);

  if (!canDoSubscription) return false;
  if (!isSensorBannerVisible) return false;
  if (!showSensorBannerFeatureFlag) return false;

  return CheckoutHelpers.canCreateSensorCheckout({
    stripeCustomerId: organisation.stripeCustomerId,
    subscriptionDetails: organisation.subscriptionDetails,
  });
}

export default useLaunchBannerEligibility;
